module.exports = __webpack_public_path__ + "static/media/header-9.a9f1af37.png";